function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import * as bodymovin from 'lottie-web';

var AnimationMaker = /*#__PURE__*/function () {
  function AnimationMaker(opts) {
    _classCallCheck(this, AnimationMaker);

    this.defaults = {
      playbackConst: 50,
      widthRatio: 1.78,
      blurbHeightArray: []
    };

    for (var key in this.defaults) {
      this[key] = this.defaults[key];
    }

    this.options = opts;

    for (var _key in opts) {
      this[_key] = opts[_key];
    }

    this.setDefaults();
    return this;
  }

  _createClass(AnimationMaker, [{
    key: "setDefaults",
    value: function setDefaults() {
      this.$el = document.querySelector(".lottie-container[data-id='".concat(this.id, "']"));
      this.$canvas = document.getElementById("".concat(this.id));
      this.$scrollTrigger = this.$el.querySelector(".scroll-trigger");
      this.$blurbs = this.$el.querySelectorAll(".blurb");
      this.$key = document.querySelector(".key.".concat(this.id));

      if (this.includeSmall && this.smallWidthRatio) {
        this.largeWidthRatio = this.widthRatio;
        this.widthRatio = window.innerWidth < 600 ? this.smallWidthRatio : this.largeWidthRatio;
      }

      this.cvs = document.getElementById(this.id); //this.ctx = this.cvs.getContext('2d');

      this.sizeCTX();
      this.renderAnimation();
      this.render();
    }
  }, {
    key: "sizeCTX",
    value: function sizeCTX() {
      var _this = this;

      var ua = window.navigator.userAgent;
      var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
      this.w_height = iOS ? window.screen.availHeight - 168 : window.innerHeight - 68;
      this.w_width = window.innerWidth;

      if (!this.fullFrame) {
        this.height = this.w_height > this.w_width / this.widthRatio ? this.w_width / this.widthRatio : this.w_height;
        this.width = this.w_height > this.w_width / this.widthRatio ? this.w_width : this.w_height * this.widthRatio;
      } else {
        this.height = this.w_height > this.w_width / this.widthRatio ? this.w_height : this.w_width / this.widthRatio;
        this.width = this.w_height > this.w_width / this.widthRatio ? this.w_height * this.widthRatio : this.w_width;
      }

      this.cvs.setAttribute('width', this.width);
      this.cvs.setAttribute('height', this.height);

      if (this.fullFrame) {
        this.svg = this.cvs.getElementsByTagName('svg');
        [].forEach.call(this.svg, function (svg, index) {
          svg.style.width = _this.width;
          svg.style.height = _this.height;
        });
      }
    }
  }, {
    key: "renderAnimation",
    value: function renderAnimation() {
      var _this2 = this;

      this.sizeLoaded = window.innerWidth < 600 && this.includeSmall ? this.id + '_sm' : this.id;
      this.animation = bodymovin.loadAnimation({
        renderer: 'svg',
        container: this.cvs,
        loop: false,
        autoplay: false,
        path: "".concat(this.graphic_url_path, "data/").concat(this.sizeLoaded, "/").concat(this.sizeLoaded, ".json")
      });
      this.animation.addEventListener('data_ready', function () {
        _this2.lastFrame = parseFloat(_this2.animation.animationData.op);
        _this2.firstFrame = parseFloat(_this2.animation.animationData.ip);
        _this2.frameRate = _this2.animation.animationData.fr;
        _this2.duration = _this2.lastFrame - _this2.firstFrame;

        _this2.$scrollTrigger.setAttribute('style', "height:".concat(_this2.duration * _this2.playbackConst, "px;"));

        if (_this2.fullFrame) {
          _this2.sizeCTX();
        }

        [].forEach.call(_this2.$blurbs, function (el, index) {
          var height = index == 0 ? (index + 0.5) * (_this2.duration * _this2.playbackConst) / _this2.blurbs.length / 2 : (index + 0.5) * (_this2.duration * _this2.playbackConst) / _this2.blurbs.length;

          if (!isNaN(parseFloat(el.getAttribute('seconds')))) {
            height = parseFloat(el.getAttribute('seconds')) * _this2.frameRate * _this2.playbackConst;
          }

          _this2.blurbHeightArray.push(height);

          el.setAttribute('style', "top:".concat(height, "px;"));
        });
      });
      this.animation.resize.bind(this.animation);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      window.addEventListener('scroll', function () {
        _this3.scrollAnimate(_this3.$scrollTrigger);

        _this3.scrollStick(_this3.$el);
      });
      window.addEventListener('resize', this.debounce(function (event) {
        _this3.resize();
      }, 100));
    }
  }, {
    key: "resize",
    value: function resize() {
      var _this4 = this;

      if (this.includeSmall && this.smallWidthRatio) {
        this.widthRatio = window.innerWidth < 600 ? this.smallWidthRatio : this.largeWidthRatio;
      }

      this.sizeCTX();
      this.sizeToLoad = window.innerWidth < 600 && this.includeSmall ? this.id + '_sm' : this.id;

      if (this.sizeLoaded != this.sizeToLoad) {
        this.animation.destroy();
        this.renderAnimation();
      } else {
        this.animation.resize();
      }

      setTimeout(function () {
        _this4.scrollAnimate(_this4.$scrollTrigger);

        _this4.scrollStick(_this4.$el);
      }, 500);
    }
  }, {
    key: "scrollAnimate",
    value: function scrollAnimate(el) {
      var _this5 = this;

      var scrollTop = window.scrollY;
      var offset = el.getBoundingClientRect().top + scrollTop;
      var bottomOfEl = offset + el.offsetHeight;
      var height = window.innerHeight;
      var triggerPoint = scrollTop + height;
      var eldistance = scrollTop + height - offset;

      if (eldistance < 0) {
        eldistance = 0;
      }

      var frameNumber = eldistance / this.playbackConst;

      if (frameNumber > this.duration - 1) {
        frameNumber = this.duration - 1;
      }

      if (this.$key) {
        var keystart = this.$key.getAttribute('keystart') ? parseFloat(this.$key.getAttribute('keystart')) * this.frameRate : 1.5 * this.frameRate;
        var keyend = this.$key.getAttribute('keyend') ? parseFloat(this.$key.getAttribute('keyend')) * this.frameRate : this.lastFrame - this.frameRate;
        var keyswitch = this.$key.getAttribute('keyswitch');

        if (frameNumber < keyend && frameNumber > keystart) {
          this.$key.classList.add('selected');
        }

        this.blurbHeightArray.forEach(function (distance, i) {
          if (eldistance > distance && eldistance < distance + _this5.frameRate * _this5.playbackConst) {
            _this5.$key.classList.add('fade');
          }

          if (eldistance > distance + _this5.frameRate * _this5.playbackConst && eldistance < _this5.blurbHeightArray[i + 1]) {
            _this5.$key.classList.remove('fade');
          }
        });

        if (frameNumber > keyend || frameNumber < keystart) {
          this.$key.classList.remove('selected');
          this.$key.classList.remove('fade');
        }

        if (keyswitch) {
          if (frameNumber > parseFloat(keyswitch) * this.frameRate) {
            this.$key.setAttribute('src', "".concat(this.graphic_url_path, "img/key_").concat(this.id, "_2.png"));
          } else {
            this.$key.setAttribute('src', "".concat(this.graphic_url_path, "img/key_").concat(this.id, ".png"));
          }
        }
      }

      if (triggerPoint > offset && scrollTop < bottomOfEl) {
        this.animation.goToAndStop(frameNumber, true);
      }
    }
  }, {
    key: "scrollStick",
    value: function scrollStick(el) {
      var scrollTop = window.scrollY;
      var offset = el.offsetTop - 68;
      var bottomOfEl = offset + el.offsetHeight;
      var height = window.innerHeight;
      var triggerPoint = scrollTop + height;

      if (scrollTop >= offset) {
        this.$el.classList.add('stuck');
      }

      if (scrollTop < offset) {
        this.$el.classList.remove('stuck');
        this.animation.goToAndStop(0, true);
      }

      if (scrollTop + height > bottomOfEl) {
        this.$el.classList.add('un-stuck');
      }

      if (scrollTop + height < bottomOfEl) {
        this.$el.classList.remove('un-stuck');
      }
    }
  }, {
    key: "debounce",
    value: function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
            args = arguments;

        var later = function later() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }
  }]);

  return AnimationMaker;
}();

export default AnimationMaker;